import { useHudStore } from "../store/hudStore";
import { WMO, weatherNote, DEFAULT_LOC } from "../data/seed";

// Real client-side date + keyless weather (Open-Meteo) + reverse-geocode
// (BigDataCloud), ported from app.html. Writes today/weather into the store so
// React re-renders (the original mutated module globals + called render()).
function applyRealDate(): void {
  const d = new Date();
  useHudStore.setState((s) => ({
    today: {
      ...s.today,
      weekday: d.toLocaleDateString("en-US", { weekday: "long" }),
      date: `${d.getDate()} ${d.toLocaleDateString("en-US", { month: "long" })} ${d.getFullYear()}`,
    },
  }));
}

async function fetchWeatherFor(lat: number, lon: number): Promise<void> {
  const wx = await fetch(
    `https://api.open-meteo.com/v1/forecast?latitude=${lat}&longitude=${lon}&current=temperature_2m,weather_code`,
  ).then((r) => r.json());
  const code = Number(wx?.current?.weather_code ?? 3);
  const t = Math.round(Number(wx?.current?.temperature_2m ?? 0));
  const w = WMO[code] ?? WMO[3] ?? { label: "Overcast", fa: "fa-solid fa-cloud", color: "var(--mut)" };
  useHudStore.setState((s) => ({
    weather: { ...s.weather, temp: t + "°", label: w.label, fa: w.fa, color: w.color, note: weatherNote(code, t) },
  }));
}

let weatherStarted = false;
export async function ensureWeather(): Promise<void> {
  if (weatherStarted) return;
  weatherStarted = true;
  applyRealDate();
  useHudStore.setState((s) => ({ today: { ...s.today, place: DEFAULT_LOC.place } }));
  try {
    await fetchWeatherFor(DEFAULT_LOC.lat, DEFAULT_LOC.lon);
  } catch (e) {
    console.warn("weather (default) failed:", (e as Error).message);
  }
  if (!navigator.geolocation) return;
  navigator.geolocation.getCurrentPosition(
    async (pos) => {
      try {
        const { latitude: lat, longitude: lon } = pos.coords;
        const geo = await fetch(
          `https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${lat}&longitude=${lon}&localityLanguage=en`,
        )
          .then((r) => r.json())
          .catch(() => null);
        await fetchWeatherFor(lat, lon);
        if (geo) {
          const city = geo.city || geo.locality || geo.principalSubdivision || "";
          const place = [city, geo.countryCode].filter(Boolean).join(", ");
          if (place) useHudStore.setState((s) => ({ today: { ...s.today, place } }));
        }
      } catch (e) {
        console.warn("weather (geo) failed:", (e as Error).message);
      }
    },
    (err) => console.warn("geolocation unavailable, staying on Tagaytay:", err.message),
    { timeout: 8000, maximumAge: 600000 },
  );
}
